<div>
    <button #profileBtn type="button" (click)="openPanel($event, profileBtn)" class="custom-profile-btn">
        <div class="user-info-container">
            <img [src]="user?.corporateAccount?.companyPhotoUrl || '/assets/images/user-default.png'" [alt]="'quickMenu.avatarAlt' | transloco" class="avatar-img" />
            <div class="user-info">
                <span class="name">{{user?.name + ' ' + user?.lastname}}</span>
                <span class="email">{{user?.email}}</span>
            </div>
        </div>
        <i class="pi pi-code rotate-90"></i>
    </button>
    
    <p-popover
    #overlay
    appendTo="body"
    [style]="{ width: 'auto' }"
    [dismissable]="true"
    styleClass="no-arrow-popover popover-manual"
    >
    <div class="user-menu-panel">
        <app-plan-view [plan]="currentPlan" [currentPlan]="user?.corporatePlan ?? null" [onlyCurrentPlan]="true"></app-plan-view>

        <ul class="menu-options">
            <li (click)="goTo('profile')"><i class="pi pi-user"></i> {{ 'quickMenu.viewProfile' | transloco }}</li>
            <li (click)="goTo('billing')"><i class="pi pi-credit-card"></i> {{ 'quickMenu.manageSubscription' | transloco }}</li>
            <li (click)="openHelpEmail()"><i class="pi pi-question-circle"></i> {{ 'quickMenu.helpCenter' | transloco }}</li>
        </ul>

        <div class="menu-divider"></div>

        <div class="logout" (click)="logout()">
            <i class="pi pi-power-off"></i> {{ 'quickMenu.logout' | transloco }}
        </div>
    </div>

    </p-popover>
</div>